<template>
    <div id="thoughtquestionresponses">
        <div v-if="!boosterData.private">
            <div class="description">Below, you'll see your response and those of other participants in this program. When you've finished reading, you may close this page. Thanks, and have a great day!</div>
            <blockquote class="response" v-for="response in boosterData.responses" v-bind:key="response"> {{ response }} </blockquote>
        </div>
        <button v-if="boosterData.previous" id="prevButton" class="ui button primary" @click="newerClick">Newer</button>
        <button v-if="boosterData.more" id="nextButton" class="ui right floated button primary " @click="olderClick">Older</button>
        <div v-if="boosterData.private">
            <div v-html="boosterData.privateMessage"></div>
            <br />
            <p>Thank you for your submission, you may now close this window.</p>
        </div>
    </div>
</template>
<script>
export default {
    name: 'ThoughtQuestionResponses',
    props: [ 'boosterData' ],
    methods: {
        olderClick: function() {
            window.location = '/booster/tq/view/'+this.boosterData.bid+'/'+(this.boosterData.page + 1)+'/view'
        },
        newerClick: function() {
            window.location = '/booster/tq/view/'+this.boosterData.bid+'/'+(this.boosterData.page - 1)+'/view'
        }
    }
}
</script>
<style scoped>

textarea {
    width: 100%;
    height: auto;
    margin-bottom: 15px;
}
blockquote{
  font-size: 1.4em;
  width:90%;
  margin:30px auto;
  font-family:Open Sans;
  font-style:italic;
  color: #555555;
  padding:1.2em 30px 1.2em 75px;
  border-left:8px solid rgb(120, 158, 192) ;
  line-height:1.6;
  position: relative;
  background:#EDEDED;
}

blockquote::before{
  font-family:Arial;
  content: "\201C";
  color:rgb(120, 170, 192);
  font-size:4em;
  position: absolute;
  left: 10px;
  top:-10px;
}

blockquote::after{
  content: '';
}
.description {
    margin: 15px;
    border-bottom: 1px solid #AAA;
    padding-bottom: 15px;
}
</style>